import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { FIELD_NAMES } from "../../../../../constants/commonConstants";
import { repaymentHelper } from "../../../../../utils/helpers/repaymentHelper";

export const useRepaymentHelper = (loanAmountFieldName) => {
  const [repaymentAmounts, setRepaymentAmounts] = useState(() => []);
  const { values } = useFormikContext();

  const loanAmount = values[loanAmountFieldName];
  const repaymentFrequency = values[FIELD_NAMES.REPAYMENT_FREQUENCY];

  useEffect(() => {
    const getRepaymentAmounts = async () => {
      const newRepaymentAmounts = await repaymentHelper(loanAmount, repaymentFrequency)
      setRepaymentAmounts(newRepaymentAmounts);
    }

    getRepaymentAmounts().finally();
  }, [setRepaymentAmounts, loanAmount, repaymentFrequency]);

  return repaymentAmounts;
};